import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { General_Interface } from '../../../Interface/General_Interface';
import { PM_V2_Assignment_Interface } from '../../../Interface/PM_V2_Interface';
import { DeviceGroupService } from '../../../Service/DeviceGroup/DeviceGroup.service';
import { PM_V2_Service } from '../../../Service/PM_V2/PM_V2.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-pm-v2-assignment-list',
  templateUrl: './PM_V2_AssignmentList.component.html',
  styleUrls: ['./PM_V2_AssignmentList.component.css']
})
export class PM_V2_AssignmentListComponent implements OnInit {
  DataList: PM_V2_Assignment_Interface[] = [];
  GroupList: General_Interface[] = [];
  SubGroupList: General_Interface[] = [];
  SelectedAssignmentIds = new Set<number>();
  TemplateTitle = '';
  GroupId = 0;
  SubGroupId = 0;
  DeviceKeyword = '';
  ActiveFilter = true;
  Procssing = false;

  page: number = 0;
  constructor(
    private service: PM_V2_Service,
    private modalService: BsModalService,
    private Alertify_Service: AlertifyService,
    private groupService: DeviceGroupService,
    private Nav_Service: NavService,
    private router: Router) { }

  ngOnInit(): void {
    this.groupService.GetDeviceGroup(0).subscribe(data => this.GroupList = data || [], error => this.HandleError(error));
    this.Nav_Service.CheckValidPage(2239).subscribe(
      data => {
        this.ReadData();
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  ReadSubGroups() {
    this.SubGroupId = 0;
    this.SubGroupList = [];
    if (this.GroupId > 0) {
      this.groupService.GetDeviceGroup(this.GroupId).subscribe(data => this.SubGroupList = data || [], error => this.HandleError(error));
    }
  }

  ReadData() {
    this.Procssing = true;
    this.service.GetAssignment(this.TemplateTitle, this.GroupId, this.SubGroupId, this.DeviceKeyword, this.ActiveFilter).subscribe(data => {
      this.DataList = data || [];
      this.SelectedAssignmentIds.clear();
      this.Procssing = false;
    }, error => this.HandleError(error));
  }

  IsSelected(id: number) { return this.SelectedAssignmentIds.has(id); }
  ToggleRow(id: number, checked: boolean) { checked ? this.SelectedAssignmentIds.add(id) : this.SelectedAssignmentIds.delete(id); }
  get AllCurrentSelected() { return this.DataList.length > 0 && this.DataList.every(x => this.IsSelected(x.id)); }
  ToggleAllCurrent(checked: boolean) { this.DataList.forEach(x => checked ? this.SelectedAssignmentIds.add(x.id) : this.SelectedAssignmentIds.delete(x.id)); }

  DeactivateSelected() {
    if (!this.ActiveFilter || this.SelectedAssignmentIds.size === 0) return;
    this.Procssing = true;
    this.service.DeactivateAssignments(Array.from(this.SelectedAssignmentIds)).subscribe(() => {
      this.Alertify_Service.SuccessMessage('تخصیص‌های انتخاب‌شده غیرفعال شدند.');
      this.modalRef_Delete.hide()
      this.ReadData();
    }, error => this.HandleError(error));
  }

  modalRef_Delete: any;
  openModal(template: TemplateRef<any>) {
    this.modalRef_Delete = this.modalService.show(template);
  }

  Add() { this.router.navigate(['/pm-v2/assignment/add']); }
  Detail(id: number) { this.router.navigate(['/pm-v2/assignment/detail', id]); }
  private HandleError(error: any) { this.Procssing = false; this.Alertify_Service.ErrorMessage(error && error.status === 404 ? 'اطلاعات نامعتبر است یا دسترسی مجاز نیست.' : 'خطا در دریافت اطلاعات.'); }
}
